export const HandleSidebar = (e) => {
  const Nav = document.querySelector(".headerNav");
  Nav.classList.toggle("active");
};
